import React from 'react';
// import "../../assets/css/master.css";

import TemplateDashboard from "../../components/TemplateDashboard";
import RetencionTutoresContent from './components/RetencionTutoresContent';

const RetencionTutoresListado = () => {

    return (
        <>

            <TemplateDashboard>
                <RetencionTutoresContent />
            </TemplateDashboard>

        </>
    )
};

export default RetencionTutoresListado;